<template>
  <div class="manager">
    <div class="itemBox">
      <div>
        <p class="left">选择员工</p>
        <p class="right">
          <el-select v-model="valueStaff" placeholder="请选择员工">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
          <span class="el-icon-arrow-right"></span>
        </p>
      </div>
      <div>
        <p>使用期限</p>
        <div class="right">
          <el-date-picker
            v-model="valueStart"
            class="begin"
            type="datetime"
            placeholder="开始日期"
          >
          </el-date-picker>
          <span class="he">-</span>
          <el-date-picker
            v-model="valueEnd"
            class="end"
            type="datetime"
            placeholder="结束日期"
          >
          </el-date-picker>
          <span class="el-icon-arrow-right jian"></span>
        </div>
      </div>
      <div>
        <p class="left">使用次数</p>
        <p class="right">
          <!-- <input type="text" placeholder="请输入次数" name="" id=""> -->
          <el-input v-model="input" placeholder="请输入次数"></el-input>
          <span class="el-icon-arrow-right"></span>
        </p>
      </div>
      <div>
        <p class="left">工卡类型</p>
        <div class="right">
          <el-select v-model="value" placeholder="请选择" @change="check">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span class="el-icon-arrow-right"></span>
        </div>
      </div>
    </div>
    <div class="ti">
      <button class="btn" @click="submit">提交</button>
    </div>
  </div>
</template>

<script>
import { staffListApi, isManagerApi, allocationApi } from "@api/login";
export default {
  data() {
    return {
      valueStart: "",
      valueEnd: "",
      valueStaff: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      options1: [
        {
          value: "1",
          label: "经理卡",
        },
        {
          value: "2",
          label: "员工卡",
        },
      ],
      input: "",
      value: "",
    };
  },
  mounted() {
    staffListApi().then((res) => {
      console.log(res, "111111111111");
      let data = [];
      this.options = res.data.data;
      console.log(data);
    });
    isManagerApi().then((res) => {
      console.log(res);
    });
  },
  methods: {
    submit() {
      // 获取员工信息
      console.log(this.value);
      let user = this.options.find((item) => {
        return item.name === this.valueStaff;
      });
      console.log(user, this.options);
      let data = {
        manage_uid: user.manage_uid,
        department_id: user.department_id,
        start_time: this.valueStart,
        end_time: this.valueEnd,
        day_count: this.input * 1,
        job_card_type: this.value,
      };
      allocationApi(data).then((res) => {
        console.log(res);
        if (res.msg === "ok") {
          this.valueStaff = "";
          this.valueStart = "";
          this.valueEnd = "";
          this.input = "";
          this.value = "";
          this.$dialog.success("分配成功");
        }
      });
    },
    check() {
      if (this.value == 1) {
        this.input = "99";
      } else {
        this.input = "2";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.manager {
  box-sizing: border-box;
  padding: 10px;
  background-color: white;
  padding-bottom: 0;
  .itemBox {
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
    }

    .right {
      display: flex;
      align-items: center;

      span {
        color: rgb(204, 196, 204);
        z-index: 10;
      }

      .he {
        display: inline-block;
        margin: 0 5px;
      }

      .jian {
        z-index: 10;
      }

      input {
        text-align: right;
        color: #ccc4cc;
      }
    }
  }
}

.ti {
  position: fixed;
  bottom: 0.2rem;
  width: calc(100vw - 0.4rem);
  left: 10px;

  button {
    width: 100%;
    height: 30px;
    background-color: red;
    color: white;
    border-radius: 15px;
  }
}
</style>
